// extracted by mini-css-extract-plugin
module.exports =  {"element":"_GAdDab4Jb4e7plibjpy"};